import { Outlet, useNavigate } from "react-router-dom";
import TenantList from "../../components/Tenant/TenantList";
import ContentLayout from "../../components/UI/Layout/ContentLayout.tsx";
// @ts-expect-error pure js
import useTenants from "../../hooks/use-tenants";
import HeaderLayout from "../../components/UI/Layout/HeaderLayout.tsx";
import VideoTutorialsButton from "../../components/VideoTutorials/VideoTutorialsButton";
import type { Tenant } from "../../models/tenant";

export default function ListPage() {
  const nav = useNavigate();
  const { tenants, isLoading } = useTenants() as {
    tenants: Tenant[];
    isLoading: boolean;
  };

  return (
    <>
      <ContentLayout
        header={
          <HeaderLayout
            title="Locataires"
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Locataires" },
            ]}
            actions={<VideoTutorialsButton page="locataires" />}
          />
        }
        body={
          <TenantList
            tenants={tenants}
            onAdd={() => nav("add")}
            isLoading={isLoading}
          />
        }
      />

      <Outlet />
    </>
  );
}
